import { Map, Record } from "immutable";
import { RootState, RootActions } from "common/reducers";
import { receive, receiveDraft, reset } from "common/reducers/Utils";
import { windowFromJSON, WindowRecord } from "common/records/Window";
import { RECEIVE_WINDOW, RECEIVE_DRAFT_WINDOW, RESET_WINDOW, UPDATE_OPENING } from "common/reducers/window.actions";
import { calculateOpeningArea, calculateOpeningUI } from "common/records/Opening";

export const WindowStateRecord = Record({
  byId: Map<number, WindowRecord>(),
  lastSavedById: Map<number, WindowRecord>(),
});

export const initialState = WindowStateRecord();
export type WindowState = typeof initialState;

const model = "windows";

export const windowReducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }
  switch (action.type) {
    case RECEIVE_WINDOW:
      return receive(state, model, windowFromJSON(action.payload.window));

    case RECEIVE_DRAFT_WINDOW:
      return receiveDraft(state, model, action.payload.window, windowFromJSON);

    case RESET_WINDOW:
      return reset(state, model, action.payload.windowId);

    case UPDATE_OPENING: {
      const { rootPath, name, value } = action.payload.event;
      const nameArray = name.split(".");
      state = state.setIn(rootPath.concat(name.split(".")), value);

      nameArray.pop();
      const width = state.getIn(rootPath.concat(nameArray.concat(["width"])));
      const height = state.getIn(rootPath.concat(nameArray.concat(["height"])));
      return state
        .setIn(rootPath.concat(nameArray.concat(["area"])), calculateOpeningArea(width, height))
        .setIn(rootPath.concat(nameArray.concat(["ui"])), calculateOpeningUI(width, height));
    }

    default:
      return state;
  }
};
